import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/City_Walk.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>City Walk</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A premium open-air retail and lifestyle destination developed by Meraas, spanning 400,000+ sqm in the heart of Dubai. City
                Walk houses a curated mix of international brands, dining, hospitality and entertainment across a walkable urban streetscape.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
              <p>GEMCO SCOPE OF WORKS : Full CHW and ducting works across the entire City Walk development</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one